<template>
    <div>
        <topLevelTenant v-if="isToptenant"></topLevelTenant>
        <otherTenant v-else></otherTenant>
    </div>
</template>
<script>
import topLevelTenant from './components/topLevelTenant/Index';
import otherTenant from './components/otherTenant/Index';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
        };
    },
    components: { topLevelTenant, otherTenant },
    computed: {
        ...mapGetters(['currentTenant']),
        isToptenant() {
            return this.currentTenant.tenantCode === 'T20191228000061';
        }
    }
};
</script>